import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, Fragment as _Fragment, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "va-rest" }
const _hoisted_2 = { class: "va-rest-main" }
const _hoisted_3 = { class: "va-rest-header" }
const _hoisted_4 = { class: "va-rest-body" }
const _hoisted_5 = { class: "va-rest-table" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }

import VASearch from '../VASearch/VASearch.vue';
import VATable from '../VATable/VATable.vue';
import VAFormDrawer from '../VAFormDrawer/VAFormDrawer.vue';
import VAPopconfirm from '../VAPopconfirm/VAPopconfirm.vue';
import RestEdit from './components/RestEdit.vue';
import propsOptions from './extends/props';
import {
  ref,
  computed,
  Ref,
} from 'vue';
import { useFormDrawer, useTableRef } from './extends/hooks';
import { VAFormItem } from '../VAForm/extends/typing';
import { formatRecordValue } from '../VATable/extends/hooks';
import { PlusOutlined, CopyOutlined } from '@ant-design/icons-vue';
import VABreadcrumb from '../VABreadcrumb/VABreadcrumb.vue';
import { KeyValueType } from '../../typing';

export default /*@__PURE__*/_defineComponent({
  __name: 'VARest',
  props: propsOptions,
  emits: [
  'beforeCreate',
  'afterCreate',
  'beforeUpdate',
  'afterUpdate',
  'beforeDelete',
  'afterDelete',
  'beforeEdit',
  'beforeAdd',
  'on-tab',
  'beforeSearch',
    'beforeClone',
    'clickAdd',
    'clickEdit'
],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const uris: Ref = computed(() => {
  return props.uris || {};
});
const searchRef = ref();

const searchParams = ref(props.searchDefaultParams || {});

const beforeSearch = (par: any) => {
  emit('beforeSearch', par, (val: any) => (par = val));
  return par;
};
const onSearch = (value: any = {}) => {
  if(searchRef.value?.parseValue){
    value = {...value, ...searchRef.value.parseValue()}
  }
  reload(beforeSearch({ ...searchParams.value, ...value }));
};
const clickAdd = () =>{
  if (props.formOptions?.length > 0){
    add()
  }else{
    emit('clickAdd')
  }
}
const clickEdit = (record: any, key: string) =>{
  if(props.formOptions?.length > 0){
    edit(record, key)
  }else{
    emit('clickEdit', record)
  }
}

// 合并query参数，新的查询query需要替代旧的query
const onChange = (value: string) => {
  emit('on-tab', value);
};
const { table, reload, remove } = useTableRef(
  uris,
  props.searchDefaultParams,
  emit,
  searchRef
);

const { visible, title, data, edit, add, cancel, submit, clone } = useFormDrawer(
  props.formOptions as Array<VAFormItem>,
  props.formDefaultParams as KeyValueType,
  emit
);

const formSubmit = (params: any) => {
  submit(params, emit, uris, onSearch);
};

const selectedRowKeys = computed(() => {
  return table.value.selectedRowKeys;
});

__expose({ onSearch, selectedRowKeys, data, visible, reload, searchRef, clone, table });

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (props.searchOptions)
          ? (_openBlock(), _createBlock(VASearch, {
              key: 0,
              size: "small",
              ref_key: "searchRef",
              ref: searchRef,
              options: props.searchOptions,
              onOnSearch: onSearch,
              onOnChange: onChange
            }, _createSlots({ _: 2 }, [
              _renderList(props.searchOptions, (item) => {
                return {
                  name: item.slot,
                  fn: _withCtx(({ data }) => [
                    _renderSlot(_ctx.$slots, item.slot, { data: data })
                  ])
                }
              })
            ]), 1032, ["options"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "restHeader")
      ]),
      _createElementVNode("div", _hoisted_4, [
        (uris.value.create)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "va-rest-add",
              onClick: clickAdd,
              type: "primary",
              size: "small"
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(PlusOutlined))
              ]),
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createTextVNode(" 添加 "))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (uris.value.list)
            ? (_openBlock(), _createBlock(VATable, {
                key: 0,
                ref_key: "table",
                ref: table,
                selection: props.selection,
                uri: uris.value.list,
                columns: props.tableColumns,
                expandedRowRender: props.expandedRowRender,
                manual: props.manual,
                expand: props.tableExpand,
                format: props.tableFormat,
                bordered: props.tableBordered,
                "row-key": props.rowKey,
                defaultParams: searchParams.value,
                "onUpdate:defaultParams": _cache[0] || (_cache[0] = ($event: any) => ((searchParams).value = $event))
              }, _createSlots({
                expandedRowRender: _withCtx(({ record }) => [
                  _renderSlot(_ctx.$slots, "expandedRowRender", { record: record })
                ]),
                expandColumnTitle: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "expandColumnTitle")
                ]),
                _: 2
              }, [
                _renderList(props.tableColumns, (column) => {
                  return {
                    name: column.slot,
                    fn: _withCtx(({ record, dataIndex, dataSource }) => [
                      (column.slot === 'edit')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (column.clone)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  onClick: ($event: any) => (_unref(clone)(record)),
                                  title: "克隆",
                                  style: {"margin-right":"5px"}
                                }, [
                                  _createVNode(_unref(CopyOutlined))
                                ], 8, _hoisted_6))
                              : _createCommentVNode("", true),
                            (uris.value.update)
                              ? (_openBlock(), _createBlock(RestEdit, {
                                  key: 1,
                                  onClick: ($event: any) => (clickEdit(record, column.dataIndex as string)),
                                  value: _unref(formatRecordValue)(record, column)
                                }, null, 8, ["onClick", "value"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (column.slot === 'action')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.options?.slots, (item) => {
                                return _renderSlot(_ctx.$slots, item, {
                                  key: item,
                                  record: record,
                                  dataSource: dataSource
                                })
                              }), 128)),
                              (uris.value.delete)
                                ? (_openBlock(), _createBlock(VAPopconfirm, {
                                    key: 0,
                                    title: "确定删除当前？",
                                    label: "删除",
                                    labelColor: "#DC143C",
                                    placeholder: "确定删除吗？",
                                    onOnOk: ($event: any) => (_unref(remove)(record))
                                  }, null, 8, ["onOnOk"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (column.slot)
                            ? _renderSlot(_ctx.$slots, column.slot, {
                                key: 2,
                                record: record,
                                dataIndex: dataIndex,
                                dataSource: dataSource
                              })
                            : _createCommentVNode("", true)
                    ])
                  }
                })
              ]), 1032, ["selection", "uri", "columns", "expandedRowRender", "manual", "expand", "format", "bordered", "row-key", "defaultParams"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (props.formOptions?.length > 0 && (uris.value.create || uris.value.update))
      ? (_openBlock(), _createBlock(VAFormDrawer, {
          key: 0,
          visible: _unref(visible),
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
          title: _unref(title),
          data: _unref(data),
          options: props.formOptions,
          onClose: _unref(cancel),
          onSubmit: formSubmit,
          formWidth: props.formWidth
        }, _createSlots({
          extra: _withCtx(() => [
            _renderSlot(_ctx.$slots, "extra")
          ]),
          customFooter: _withCtx(() => [
            _renderSlot(_ctx.$slots, "customFooter")
          ]),
          _: 2
        }, [
          _renderList(props.formOptions, (v) => {
            return {
              name: v.slot,
              fn: _withCtx(({ item, data }) => [
                (v.slot)
                  ? _renderSlot(_ctx.$slots, v.slot, {
                      key: 0,
                      item: item,
                      data: data
                    })
                  : _createCommentVNode("", true)
              ])
            }
          })
        ]), 1032, ["visible", "title", "data", "options", "onClose", "formWidth"]))
      : _createCommentVNode("", true)
  ]))
}
}

})